import classNames from 'classnames';
import { ComponentProps } from 'react';

import CleanButton from '../CleanButton/CleanButton';
import SVG from '../SVG/SVG';

import styles from './FieldIconButton.module.css';

type FieldIconButtonProps = {
    icon: string;
    variant?: 'default' | 'brand' | 'subtle' | 'inside' | 'inside-pill';
    disabled?: boolean;
} & Omit<
    ComponentProps<typeof CleanButton>,
    'disabled' | 'children' | 'tabIndex'
>;

const FieldIconButton = ({
    icon,
    variant = 'default',
    disabled = false,
    className,
    ...buttonProps
}: FieldIconButtonProps) => {
    const classes = classNames(className, styles.Root, {
        [styles.variantDefault]: variant === 'default',
        [styles.variantSubtle]: variant === 'subtle',
        [styles.variantBrand]: variant === 'brand',
        [styles.variantInside]: variant === 'inside',
        [styles.variantInsidePill]: variant === 'inside-pill',
        [styles.disabled]: disabled,
    });

    const isInside = variant === 'inside' || variant === 'inside-pill';

    return (
        <CleanButton
            {...buttonProps}
            className={classes}
            disabled={disabled}
            tabIndex={-1}
        >
            <SVG
                src={icon}
                className={classNames(
                    styles.Icon,
                    isInside && styles.Icon_small
                )}
            />
        </CleanButton>
    );
};

export default FieldIconButton;
